import { Controller, useFormContext } from 'react-hook-form';
import React from 'react';
import { EqualisationSettingsFormValues } from './FormWrapper';
import { Column } from 'further-ui/components/Layout';
import PageSection from 'components/new/PageSection';
import FormField from 'further-ui/components/FormField';
import DayCountSelect from '../DayCountSelect';

const OverallEqualisationInterestSettings: React.FC = () => {
  const { control } = useFormContext<EqualisationSettingsFormValues>();

  return (
    <Column spacing="lg">
      <PageSection title="Overall equalisation interest settings" />
      <FormField
        size="md"
        label="Equalisation interest day count"
        tooltip="This is the day count option used for calculating the equalisation interest across the fund vehicle."
      >
        <Controller
          name="dayCount"
          control={control}
          render={({ fieldState: { error }, field: { onChange, value } }) => (
            <DayCountSelect value={value} onChange={onChange} error={!!error} />
          )}
        />
      </FormField>
    </Column>
  );
};

export default OverallEqualisationInterestSettings;
